import { useState } from 'react'
import { getClassNameForField, volunteerFields as fields } from '../../constants'
import { EditableFormPage } from '../components/EditableFormPage'
import { useParams } from 'react-router-dom'
import { Button } from '../../shared/components/Button'
import { FaTrash } from 'react-icons/fa'
import { useDeleteItem } from '../../util/deleteItem'
import ConfirmDeleteModal from '../components/DeleteModal'
import { useTranslationService } from '../../util/TranslationContext'
import { useTranslation } from 'react-i18next'

const VolunteersSlug = () => {
    const [showConfirm, setShowConfirm] = useState(false)
    const { t } = useTranslation()

    const { translateFields } = useTranslationService()
    const volunteerFields = translateFields(fields, 'volunteer')

    const { id } = useParams()

    const deleteItem = useDeleteItem()
    const handleDelete = async () => {
        await deleteItem({
            url: `admin/volunteers/${id}`,
            navigateSuccess: '/admin/auth/volunteers',
            onError: msg => alert(msg),
        })
    }

    return (
        <>
            <div className='flex items-center justify-between'>
                <Button variant='danger' className='mb-4' onClick={() => setShowConfirm(true)}>
                    <FaTrash /> {t('status.delete')}
                </Button>

                <ConfirmDeleteModal
                    isOpen={showConfirm}
                    onClose={() => setShowConfirm(false)}
                    onConfirm={handleDelete}
                />
            </div>
            <EditableFormPage
                fetchUrl={`admin/volunteers/${id}`}
                fields={volunteerFields}
                classNameForField={getClassNameForField}
                errorMessage='Failed to fetch project data.'
                acceptJSON={true}
                method='PUT'
            />
        </>
    )
}

export default VolunteersSlug
